export default __webpack_public_path__ + "static/media/shard-relationships-inactive.0f24f183.jpg";